import { render, staticRenderFns } from "./WindSpeed.vue?vue&type=template&id=51738f22&scoped=true&"
import script from "./WindSpeed.vue?vue&type=script&lang=js&"
export * from "./WindSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51738f22",
  null
  
)

component.options.__file = "WindSpeed.vue"
export default component.exports